import { useState } from 'react'
import { uuid } from '@10000/common'
import { useBreakpoints, usePublish, useRequest, useView } from '@10000/react'
import { Body, Box, Button, Dialog, H4 } from '../widgets'
import { Subscriptions } from '../onboarding/payment'
import { useStack } from '../layout'

export const FreeButtonBar = ({ displayMode }) => {
  const squizPublish = usePublish('squiz')
  const tenantRequest = useRequest('tenant')
  const tenantPublish = usePublish('tenant')
  const { options, presenter } = useView('squiz')
  const { subscription: { signupStarted } } = useView('tenant')
  const { parent } = useStack()
  const { mobile } = useBreakpoints()
  const [confirmTeamMode, setConfirmTeamMode] = useState(false)

  const tryTeamMode = () => {
    setConfirmTeamMode(false)
    const id = uuid()
    squizPublish('squizExited')
    return tenantRequest('squizCreated', {
      id,
      teamId: 'free',
      options: {
        free: true,
        solo: false,
        presenterParticipates: true,
        tutorial: true,
        guides: true,
        consensus: true,
        questionCount: 2
      }
    })
  }

  const subscribe = async () => {
    setConfirmTeamMode(false)
    if(!signupStarted) {
      await tenantPublish('signupStarted')
    }
    parent.push([{ Component: Subscriptions, props: { fromFreeSquiz: true } }])
  }

  return (presenter && options?.free && !displayMode) && <>
    <Box
      position={!mobile && 'absolute'}
      fullWidth={mobile}
      top={16}
      right={32}
      p={10}
      r={100}
      background="rgba(255, 255, 255, 0.5)"
      gap={8}
      zIndex={!mobile && 100}
    >
      {options?.solo &&
        <Button
          small
          light
          fullWidth={mobile}
          style={{ background: 'black', color: 'white', height: 31, minHeight: 31 }}
          onClick={() => setConfirmTeamMode(true)}
        >
          Try Team Mode
        </Button>
      }
      <Button
        small
        light
        fullWidth={mobile}
        style={{ outline: '1px white', height: 31, minHeight: 31 }}
        onClick={subscribe}
      >
        Subscribe
      </Button>
    </Box>
    <Dialog open={confirmTeamMode} mobileBackground="white" mobileDrawer={false} showControls={false} onClose={() => setConfirmTeamMode(false)} alignItems="start">
      <H4 color="black" align="left">Try Team Mode</H4>
      <Body color="black">Experience Shivoo exactly as intended. Assemble your team and have each player join using their own device.</Body>
      <Box fullWidth alignItems="center" justifyContent="space-between">
        <Body color="black" bold italic underline onClick={subscribe}>
          Ready to subscribe?
        </Body>
        <Button onClick={tryTeamMode}>
          Switch to Team Mode
        </Button>
      </Box>
    </Dialog>
  </>
}
